import Service from "../Service";
import Vue from "vue";
const resource = "general/area/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },
    excel(cmp, requestID) {
        return Service.post(resource + "reportexcel", cmp, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

};